import { Contact } from './contactTypes';

export interface Address {
  id: number;
  line1: string | null;
  line2: string | null;
  city: string | null;
  postcode: string | null;
  country: string | null;
  latitude: number | null;
  longitude: number | null;
}

export type PartialAddress = Partial<
  Pick<
    Address,
    | 'line1'
    | 'line2'
    | 'city'
    | 'postcode'
    | 'country'
    | 'latitude'
    | 'longitude'
  >
>;

/**
 * An address whose keys are all mandatory, though each value may be null or
 * undefined. Unlike `PartialAddress` (every key optional), this forces callers
 * to map every field explicitly, so a GraphQL address object — whose postcode
 * field is named `postalCode` — can't be passed straight through and silently
 * drop a field from the rendered address.
 */
export type NullishAddress = {
  [K in keyof Pick<
    Address,
    'line1' | 'line2' | 'city' | 'postcode' | 'country'
  >]: Address[K] | undefined;
};

export enum LocationOptionType {
  SITE = 'SITE',
  CUSTOMER = 'CUSTOMER',
}

export type LocationOption = {
  id: number;
  type?: LocationOptionType;
  address: Address;
  contacts: Contact[];
};
